import { rem } from "@certn/cascadia/utils";
import {
  GhostButton,
  GhostIconButton,
  MediaQuery,
  useColors,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useAdaChat } from "./AdaChatContext";

export function HelpButton() {
  const adaChat = useAdaChat();
  const { t } = useTranslation();
  const colors = useColors();

  if (!adaChat) return null;

  const { hasUnread, toggle } = adaChat;

  return (
    <div className={styles.wrapper}>
      <MediaQuery sm md type="hide">
        <GhostButton
          size="medium"
          leftIcon="help"
          iconType="standard"
          onPress={toggle}
          testID="help-button"
        >
          {t("Get help")}
        </GhostButton>
      </MediaQuery>
      <MediaQuery lg xl type="hide">
        <GhostIconButton
          icon="help"
          aria-label={t("Get help")}
          onPress={toggle}
          testID="help-icon-button"
        />
      </MediaQuery>
      {hasUnread && (
        <span
          aria-hidden
          data-testid="help-button-unread-badge"
          className={css(styles.badge, {
            background: colors["background-danger-strong"],
            boxShadow: `0 0 0 ${rem("space-05")} ${colors["background-base"]}`,
          })}
        />
      )}
    </div>
  );
}

const styles = {
  wrapper: css({
    position: "relative",
    display: "inline-flex",
  }),
  badge: css({
    position: "absolute",
    top: rem("space-05"),
    right: rem("space-05"),
    width: rem("space-2"),
    height: rem("space-2"),
    borderRadius: "50%",
    pointerEvents: "none",
  }),
};
